<template>
  <el-dialog class="modalStyle" :visible="visible" width="56%" title="订单详情" :before-close="handleClose">
    <div class="container">
      <div class="top">
         <!-- <Icon type="check-circle" theme="filled" /> -->
         当前订单状态：{{orderStatus.get(orderDetail.order_status)}}</div>
      <div class="middle">
        <div class="title">
          商品信息
        </div>
        <table>
          <th>
            <td>药品名称/规格</td><td>生产厂家</td><td>单价</td><td>数量</td><td>小计</td>
          </th>
          <tr v-for="(item, i) in orderDetail.order_goods" :key="i">
            <td>
              <img :src="spliceImg(item.original_img)"/>
              {{item.goods_name}}<br />{{item.goods_spec}}
            </td>
            <td>{{item.manufacturer_name}}</td>
            <td>{{item.market_price}}</td>
            <td>{{item.goods_num}}</td>
            <td>{{item.pay_price}}</td>
          </tr>
        </table>
        <div class="price">
          <div class="left">
            <div class="left_left">订单备注：</div>
            <div class="left_right">{{orderDetail.user_note}}</div>
          </div>
          <div class="right">
            <div class="right_field">
              <div class="field_name">总价</div>
              <div class="field_value">￥{{orderDetail.total_amount}}</div>
            </div>
            <div class="right_field">
              <div class="field_name">实付款</div>
              <div class="field_value">￥{{orderDetail.order_amount}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="title">
          交易信息
        </div>
        <div class="order_field" style="width: 100%">
          订单编号：{{orderDetail.order_sn}}
        </div>
        <div class="order_field">
          交易时间：{{orderDetail.add_time}}
        </div>
        <div class="order_field">
          付款时间：{{ (orderDetail.pay_time * 1000) | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </div>
        <div class="order_field">
          付款方式：{{orderDetail.pay_type === 1 ? '预付款' : '普通付款'}}
        </div>
        <div class="order_field">
          付款渠道：{{payWay.get(orderDetail.pay_way)}}
        </div>
        <div class="order_field">
          发货时间：{{orderDetail.shipping_name}}
        </div>
        <div class="order_field">
          快递名称：{{orderDetail.shipping_name}}
        </div>
        <div class="order_field">
          快递单号：{{orderDetail.shipping_sn}}
        </div>
        <div class="order_field">
          退款金额：{{orderDetail.return_price}}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

const payWay = new Map([
    ['wx', '微信'],
    ['ali', '支付宝'],
    ['other', '其他'],
]);

const orderStatus = new Map([
    [0, '未付款'],
    [2, '已付款'],
    [3, '发货中'],
    [4, '订单完成'],
    [6, '退货中'],
    [7, '退款中'],
    [8, '退款完成'],
    [9, '付款中'],
    [-1, '订单关闭/订单过期'],
]);

  export default {
    name: 'orderDetail',
    data() {
      return {
        payWay,
        visible: false,
        orderStatus,
        orderDetail: {},
      }
    },
    methods: {
      open(item) {
        this.orderDetail = item;
        this.visible = true;
        console.log(item);
      },
      handleClose() {
        this.visible = false;
      },
      spliceImg(imgStr = '') {
        const url = 'https://api.goodyiyao.cn/';
        return imgStr.match(/^http|https/) ? imgStr : (url + imgStr);
      },
    }
  }
</script>

<style lang="scss" scoped>

.container {
  margin: 20px;
  .top {
    border: 1px solid #aaa;
    padding: 10px 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .anticon {
      color: rgb(43, 255, 0);
      font-size: 30px;
      margin-right: 10px;
    }
  }
  .middle {
    border: 1px solid #aaa;
    margin: 10px 0;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    table {
      display: table;
      width: 100%;
      margin-top: 10px;
      th {
        display: table-header-group;
        td {
          width: 16%;
          display: table-cell;
          vertical-align: middle;
          &:first-child {
            width: 36%;
          }
        }
      }
      tr {
        // display: table-column-group;
        td {
          &:first-child {
            img {
              height: 50px;
              width: 60px;
            }
          }
        }
      }
    }
  }


  .title {
    padding-left: 20px;
    position: relative;
    margin-left: 10px;
    &::before {
      content: ' ';
      background: #1d90d0;
      width: 4px;
      position: absolute;
      left: 0;
      height: 100%;
    }
  }
}
.modalStyle {
  /deep/ {
    .el-dialog__close {
      color: #fff;
    }
    .el-dialog__header {
      background: #1d90d0;

      .el-dialog__title {
        color: #fff;
      }
    }
    .el-dialog__body {
      
    }
  }
}
.price {
  display: flex;
  .left {
    flex: 1;
    display: flex;
    &_left {
      font-weight: bold;
    }
    &_right{
      
    }
  }
  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    &_field {
      width: 200px;
      display: flex;
      justify-content: space-between;
      .field_name {
        font-weight: bold;
      }
      .field_value {
        color: red;
      }
    }
  }
}
.bottom {
  display: inline-block;
  border: 1px solid #aaa;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  .order_field {
    font-weight: bold;
    width: 25%;
    white-space: nowrap;
    margin: 10px 0;
    font-size: 12px;
    float: left;
  }
}
</style>